module.exports = __webpack_public_path__ + "2a3bbf17adddff5b49a86b5fdb7c8ffd.MP3";